import { render, staticRenderFns } from "./FinanceIndex.vue?vue&type=template&id=10690b4f"
import script from "./FinanceIndex.vue?vue&type=script&lang=js"
export * from "./FinanceIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports